import React from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { motion } from "framer-motion";
import { MotionBox } from "@rusha/shared-theme";
import {
  contentContainerInitial,
  contentContainerInView,
  contentContainerTransition,
  heroHeadingTransition,
  heroBodyTransition,
  buttonHover,
  buttonTap,
} from "./HeroAnimations";

const MotionTypography = motion.create(Typography);

const HeroContent: React.FC = () => (
  <Grid item xs={12} md={6}>
    <MotionBox
      sx={{ position: "relative", zIndex: 1 }}
      initial={contentContainerInitial}
      whileInView={contentContainerInView}
      viewport={{ once: true }}
      transition={contentContainerTransition}
    >
      <MotionTypography
        variant="h1"
        sx={{
          mb: 2,
          fontWeight: 800,
          fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
        }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={heroHeadingTransition}
      >
        Cloud Deployments{" "}
        <Box component="span" sx={{ color: "primary.main" }}>
          Made Simple
        </Box>
      </MotionTypography>

      <MotionTypography
        variant="body1"
        sx={{
          mb: 4,
          fontSize: "1.2rem",
          color: "text.secondary",
          maxWidth: "500px",
        }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={heroBodyTransition}
      >
        Streamline your deployment process with templates for popular
        application stacks that deploy seamlessly to any cloud provider.
      </MotionTypography>

      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: { xs: "wrap", sm: "nowrap" },
        }}
      >
        <MotionBox
          whileHover={buttonHover}
          whileTap={buttonTap}
          sx={{ width: { xs: "100%", sm: "auto" } }}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            component="a"
            href="https://app.rusha.tierravivaai.net"
            sx={{ width: "100%" }}
          >
            Get Started
          </Button>
        </MotionBox>

        <MotionBox
          whileHover={buttonHover}
          whileTap={buttonTap}
          sx={{ width: { xs: "100%", sm: "auto" } }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="large"
            component="a"
            href="#features"
            sx={{ width: "100%" }}
          >
            Learn More
          </Button>
        </MotionBox>
      </Box>
    </MotionBox>
  </Grid>
);

export default HeroContent;
